<template>
  <div class="flex gap-2.5 max-sm:gap-2" role="group" :aria-label="tr('Automation type')">
    <label
      v-for="action in actions"
      :key="action.value"
      :class="[
        'inline-flex h-9 items-center gap-2.5 rounded-lg border px-3.5 text-sm whitespace-nowrap text-foreground transition-colors max-sm:min-w-0 max-sm:flex-1 max-sm:justify-center max-sm:gap-1.5 max-sm:px-2 max-sm:text-[13px]',
        actionFilter.includes(action.value) ? action.style.chip : 'glass-input border-border',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
      ]"
    >
      <ui-checkbox
        :model-value="actionFilter.includes(action.value)"
        :disabled="disabled"
        :class="[ 'size-4.5', action.style.checkbox ]"
        @update:model-value="() => toggle(action.value)"
      />
      {{ action.label }}
    </label>
  </div>
</template>

<script>
import { RULE_ACTION } from '@/consts.js';
import { ruleActionStyle } from '@/ui/utils/ruleAction.js';

/** Automation type toggles of the automation list; at least one stays on. */
export default {
  name: 'RuleActionFilter',
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  computed: {
    actionFilter() {
      return this.$store.getters['rules/actionFilter'];
    },
    actions() {
      return [
        { value: RULE_ACTION.START, label: this.tr('Ad Creation') },
        { value: RULE_ACTION.SCALING_UP, label: this.tr('Ad Scaling') },
        { value: RULE_ACTION.STOP, label: this.tr('Ad Stop') },
      ].map(action => ({ ...action, style: ruleActionStyle(action.value) }));
    },
  },
  methods: {
    toggle(action) {
      if (!this.actionFilter.includes(action)) {
        this.$store.commit('rules/setActionFilter', [ ...this.actionFilter, action ]);
        return;
      }

      if (this.actionFilter.length === 1) {
        this.infoToast(this.tr('At least one automation type must be selected.'));
        return;
      }

      this.$store.commit('rules/setActionFilter', this.actionFilter.filter(item => item !== action));
    },
  },
};
</script>
